<div class="container">
  <div class="editor-container" *ngIf="showCommand">
    <textarea #sqlEditor [(ngModel)]="command" placeholder="Comando SQL"></textarea>
  </div>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="execute()">Executar</button>
    <button mat-raised-button (click)="toggleCommand()">
      Esconder Comando
    </button>
    <button mat-raised-button (click)="toggleResults()">
      Esconder Resultados
    </button>
  </div>
  <div class="result-container" *ngIf="showResults">
    <div *ngIf="error" class="error-container" style="height: 100%;">
      <textarea [ngModel]="error" readonly class="error-text" placeholder="Erro"></textarea>
    </div>

    <mat-tab-group *ngIf="executionResult" animationDuration="0ms" style="height: 100%;">
      <mat-tab label="Results">
        <div class="tab-content" style="height: 100%; overflow: auto;">
          <ng-container *ngIf="executionResult.results && executionResult.results.length > 0; else noResults">
            <div *ngFor="let res of executionResult.results; let i = index" class="result-item" [style.height]="executionResult.results.length > 1 ? '50%' : '100%'">
              <div class="table-container" *ngIf="res && res.length > 0; else emptyRes">
                <ng-container *ngIf="getColumns(res) as columns">
                  <table>
                    <thead>
                      <tr>
                        <th *ngFor="let col of columns">{{col}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of res">
                        <td *ngFor="let col of columns">
                          <ng-container *ngIf="row[col] !== null; else nullValue">{{row[col]}}</ng-container>
                          <ng-template #nullValue><span class="null-value">NULL</span></ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>
              </div>
              <ng-template #emptyRes>
                 <div class="empty-message">No rows returned.</div>
              </ng-template>
            </div>
          </ng-container>
          <ng-template #noResults>
             <div class="empty-message">No data returned.</div>
          </ng-template>
        </div>
      </mat-tab>
      <mat-tab label="Messages">
        <div class="tab-content" style="height: 100%;">
          <textarea [ngModel]="executionResult.messages.join('\n')" readonly placeholder="Messages"></textarea>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div *ngIf="!executionResult && !error" class="empty-result" style="height: 100%;">
      <textarea readonly placeholder="Resultado SQL"></textarea>
    </div>
  </div>
</div>
